import React from 'react'
import Slider from 'react-slick'
import SbEditable from 'storyblok-react'
import Image from '../atoms/Image'
import Link from '../atoms/Link'

const ProductGalleryBlock = ({ block }) => {
  function NextArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-right"></i>
      </span>
    )
  }

  function PrevArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-left"></i>
      </span>
    )
  }
  const settings = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow className="slick-prev" />,
    nextArrow: <NextArrow className="slick-next" />,
  }
  return (
    <SbEditable content={block}>
      <Slider {...settings} className="product-gallery-block">
        {block.body?.length > 0 &&
          block.body?.map((item, index) => (
            <article className="product-gallery-block-item" key={index}>
              <div className="product-gallery-block-item-image-container">
                <div className="product-gallery-block-item-image">
                  <div data-rellax-center={true} data-rellax-speed={-3}>
                    <Image
                      className="img-fluid"
                      image={item.augmented_image?.image}
                      imageWidth="1397"
                      imageHeight="786"
                      alt={item.alt}
                    />
                  </div>
                </div>
              </div>
              <div
                data-rellax-center={true}
                data-rellax-speed={-3}
                className="product-gallery-block-item-overlay"
              >
                {item.augmented_image?.hotspots?.length > 0 &&
                  item.augmented_image.hotspots.map((hotspot, index) => (
                    <div
                      className={`product-gallery-block-item-hotspot ${
                        hotspot.x > 70 &&
                        'product-gallery-block-item-hotspot-open-to-left'
                      }`}
                      style={
                        hotspot.x > 70
                          ? {
                              top: `${hotspot.y}%`,
                              right: `calc(100% - ${hotspot.x}%`,
                            }
                          : {
                              top: `${hotspot.y}%`,
                              left: `${hotspot.x}%`,
                            }
                      }
                      key={index}
                    >
                      {hotspot.x > 70 && (
                        <div className="product-gallery-block-item-hotspot-dot">
                          <i className="fal fa-plus"></i>
                        </div>
                      )}
                      {hotspot.internallinkurl?.length > 0 ? (
                        <Link
                          className="product-gallery-block-item-hotspot-text"
                          link={`/${hotspot.internallinkurl}`}
                        >
                          <div className="product-gallery-block-item-hotspot-title">
                            {hotspot.title}
                          </div>
                          <div className="product-gallery-block-item-hotspot-subtitle">
                            {hotspot.text}
                          </div>
                        </Link>
                      ) : hotspot.linkurl?.length > 0 ? (
                        <Link
                          className="product-gallery-block-item-hotspot-text"
                          link={hotspot.linkurl}
                        >
                          <div className="product-gallery-block-item-hotspot-title">
                            {hotspot.title}
                          </div>
                          <div className="product-gallery-block-item-hotspot-subtitle">
                            {hotspot.text}
                          </div>
                        </Link>
                      ) : (
                        <div className="product-gallery-block-item-hotspot-text">
                          <div className="product-gallery-block-item-hotspot-title">
                            {hotspot.title}
                          </div>
                          <div className="product-gallery-block-item-hotspot-subtitle">
                            {hotspot.text}
                          </div>
                        </div>
                      )}
                      {hotspot.x <= 70 && (
                        <div className="product-gallery-block-item-hotspot-dot">
                          <i className="fal fa-plus"></i>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </article>
          ))}
      </Slider>
    </SbEditable>
  )
}

export default ProductGalleryBlock
